<template>
    <div class="footer">
        <el-row class="footer-row" type="flex" align="middle" :gutter="0">
            <el-col :span="8" class="footer-col">
                <div class="footer-cell footer-cell-copyright">
                    <p v-if="language === 'zh'" class="copyright copyright-zh">© 2021-2026 龚卿 保留所有权利</p>
                    <p v-else class="copyright">© Copyright 2021-2026 GONG Qing All Rights Reserved</p>
                </div>
            </el-col>
            <el-col :span="8" class="footer-col">
                <div class="footer-cell footer-cell-icp">
                    <img src="../assets/备案图标.png.webp" class="icp-icon" alt="" />
                    <a class="icplink" href="https://beian.mps.gov.cn/#/query/webSearch?code=33010602013385\" target="_blank">浙公网安备33010602013385</a>
                    <a class="icplink icp-gap" target="_blank" href="https://beian.miit.gov.cn/?spm=5176.28508143.J_9220772140.60.e939154a3Ui8Au#/Integrated/index" >浙ICP备2022003402号-1</a>
                </div>
            </el-col>
            <el-col :span="8" class="footer-col">
                <div class="footer-cell footer-cell-email">
                    <i class="el-icon-message"></i>
                    <span class="email-text">gongqing@zju.edu.cn</span>
                </div>
            </el-col>
        </el-row>

<!--                    <div class="footer-content" >-->
<!--                        <i class="el-icon-user"></i>-->
<!--                        <a target="_blank" href="https://github.com/oDumbledoreArmyo">-->
<!--                            <p style="border-bottom: 1px solid black" >Github</p>-->
<!--                        </a>-->
<!--                    </div>-->


<!--                    <div class="footer-content" >-->
<!--                        <i class="el-icon-document"></i>-->
<!--                        <a target="_blank" href="https://www.yuque.com/ogongqingo/qnls">-->
<!--                            <p style="border-bottom: 1px solid black" >Yuque</p>-->
<!--                        </a>-->
<!--                    </div>-->


<!--                    <div class="footer-content" >-->
<!--                        <i class="el-icon-mobile-phone"></i>-->
<!--                        <a target="_blank" href="https://space.bilibili.com/5065303">-->
<!--                            <p style="border-bottom: 1px solid black" >Bilibili</p>-->
<!--                        </a>-->
<!--                    </div>-->

    </div>
</template>

<script>
    export default {
        name: "Footer",
        props: {
            language: {
                type: String,
                default: "zh"
            }
        }
    }
</script>

<style scoped>
    .footer-row {
        flex-wrap: wrap;
    }
    .footer-col {
        display: flex !important;
        justify-content: center;
        align-items: center;
        min-height: 44px;
    }
    .footer-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        padding: 0 8px;
    }
    .footer-cell-copyright {
        flex-wrap: wrap;
    }
    .copyright{
        color: #666;
        text-decoration: none;
        font-size: 12px;
        line-height: 1.45;
        margin: 0;
        max-width: 100%;
    }
    .copyright-zh{
        letter-spacing: 0.5px;
    }
    .footer-cell-icp {
        flex-wrap: wrap;
        gap: 0 8px;
    }
    .icp-icon {
        width: 15px;
        height: 15px;
        margin-right: 0;
        flex-shrink: 0;
        vertical-align: middle;
    }
    .icplink{
        color: #666;
        text-decoration: none;
        font-size: 12px;
        line-height: 1.45;
        white-space: nowrap;
    }
    .icp-gap {
        margin-left: 24px;
    }
    @media (max-width: 900px) {
        .icp-gap {
            margin-left: 0;
        }
        .footer-cell-icp {
            flex-direction: column;
            gap: 6px;
        }
    }
    .icplink:hover{
        opacity: 60%;
    }
    .footer{
        margin-top: 200px;
        margin-bottom: 50px;
        min-height: 36px;
    }
    .footer-cell-email {
        flex-direction: row;
        gap: 10px;
    }
    .footer-cell-email .el-icon-message {
        color: #666;
        font-size: 22px;
        line-height: 1;
        flex-shrink: 0;
    }
    .email-text {
        color: #666;
        font-weight: 400;
        font-size: 12px;
        line-height: 1.45;
        margin: 0;
        word-break: break-all;
    }
</style>
